export default [
  {
    path: '/security-center',
    name: 'securityCenter',
    component: () => import('views/security-center/security-center'),
    meta: {
      needToken: true
    }
  },
  {
    path: '/pay-pwd',
    name: 'payPwd',
    component: () => import('views/security-center/pay-pwd.vue'),
    meta: {
      needToken: true
    }
  },
  {
    path: '/change-phone',
    name: 'changePhone',
    component: () => import('views/security-center/change-phone.vue'),
    meta: {
      needToken: true
    }
  }
];
